import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useEffect } from 'react';

import {
  TRACKING_EVENT_NAMES,
  ACTION_SUBJECT_IDS
} from '../../utils/constants';
import {
  bodyStyle,
  containerStyle,
  headerStyle,
  linkStyle
} from './error-state.styles';
import { ErrorIcon } from './error-icon';

interface ErrorStateProps {
  analyticsAttributes: object;
}

export const ErrorState = ({ analyticsAttributes }: ErrorStateProps) => {
  const { createAnalyticsEvent } = useAnalyticsEvents();

  useEffect(() => {
    createAnalyticsEvent({
      eventName: TRACKING_EVENT_NAMES.errorScreenDisplayed,
      action: 'displayed',
      actionSubject: 'errorScreen',
      actionSubjectId: ACTION_SUBJECT_IDS.wacCartPopoverErrorScreen,
      attributes: analyticsAttributes
    }).fire();
  }, []);

  return (
    <div css={containerStyle} data-testid="admin-cart-error-state">
      <ErrorIcon />
      <h3 css={headerStyle}>Failed to load trial details</h3>
      <div css={bodyStyle}>
        We couldn&apos;t get info about some of the products you&apos;re
        trialing. Try loading your trial details again. If the problem persists,{' '}
        <a
          css={linkStyle}
          href="https://support.atlassian.com/contact"
          target="_blank"
          rel="noreferrer"
        >
          contact support
        </a>
        .
      </div>
    </div>
  );
};
